// Адрес вкладки «Расчёт сотрудника»: живёт в «Расчёте», а ведут на неё и из карточки человека.
//
// Опознаватели объявлены ЗДЕСЬ, в общем слое, а раздел «Расчёт» их только пересказывает: иначе
// карточке человека пришлось бы ходить за ними в чужой раздел (как с переносом остатков долгов,
// `shared/debts/перенос.ts`).

/** Вид раздела «Расчёт» (`/payroll/<вид>`). */
export const ВИД_РАСЧЁТА_СОТРУДНИКА = 'settlement';

/** Выбранный человек: ?f.employee=<id>. */
export const ОТБОР_СОТРУДНИКА = 'employee';

/** Границы расчёта: ?f.from=2025-11&f.to=2026-03. Не заданы — период выбирает сервер. */
export const ОТБОР_С = 'from';
export const ОТБОР_ПО = 'to';

/**
 * Адрес расчёта конкретного человека. Документ строится сразу, как только адрес открыт:
 * кнопки «Рассчитать» внутри вкладки нет, выбор человека и есть действие.
 */
export function адресРасчётаСотрудника(employeeId: string): string {
  return `/payroll/${ВИД_РАСЧЁТА_СОТРУДНИКА}?f.${ОТБОР_СОТРУДНИКА}=${encodeURIComponent(employeeId)}`;
}
